<template>
    <div id="event-group">
        <div class="row topactionform smallmargin">
            <div class="col-xs-4"><div class="smalltitle">Daily Sales Report</div></div>
            <div class="col-xs-8">
                <form class="onelineform flowsearch" @submit.prevent="submitSearchBill">
                    <button type="submit" class="submit btn light" style="float: right; width: 10% !important;"><i class="fa fa-search"></i></button>
                    <span class="selectwrap" style="width: 15%; float: right">
                        <select>
                            <option value="">Itemized bills</option>
                            <option value="">Registration fee</option>
                            <option value="">Additional fee</option>
                            <option value="">Sponsorship</option>
                            <option value="">Membership</option>
                            <option value="">EMR Pro Package</option>
                            <option value="">EMR Pro with e-prescribe</option>
                            <option value="">EMR Complete suite</option>
                        </select>
                    </span>
                    <span class="selectwrap" style="width: 15%; float: right">
                        <select>
                          <option value="">Type</option>
                          <option value="">Membership</option>
                          <option value="">Event</option>
                          <option value="">Patient bill</option>
                        </select>
                    </span>
                    <span class="selectwrap" style="width: 15%; float: right">
                        <select>
                          <option value="">Vendor</option>
                          <option value="">WikiAllergies</option>
                          <option value="">Group</option>
                          <option value="">Clinic</option>
                        </select>
                    </span>
                    <date-picker
                                 format="MM/DD/YYYY"
                                 :clearable="true"
                                 :append-to-body=true
                                 :custom-button=true
                                 style="float: right;">
                    </date-picker>
                    <input type="text" placeholder="MRN, patient name or leave blank for search all"
                           class="keyinput" style="width: 25%; border-left: 1px solid #e1e1e1; float: right">
                </form>
            </div>
        </div>
        <div class="blockcont"></div>
        <div class="daily-bill-report-wrap">
            <div class="ledgersum daily">
                <div>Total Charge
                    <span class="font-total-big">0</span>
                </div>
                <div>Biologic Cost
                    <span class="font-total-big">0</span>
                </div>
                <div style="font-size: 11px !important;">NET INS PAY
                    <span class="main-patient-payment-method font-total-big">0</span>
                    <span class="patient-payment-method">INS PAY: 0</span>
                    <span class="patient-payment-method">INS ADJ: 0</span>
                </div>
                <div>CHARGE ADJUSTMENT
                    <span class="main-patient-payment-method font-total-big">0</span>
                    <span class="patient-payment-method"> +0</span>
                    <span class="patient-payment-method"> -0</span>
                </div>
                <div>MISCELANEOUS
                    <span class="main-patient-payment-method font-total-big">0 </span>
                    <span class="patient-payment-method"> +0</span>
                    <span class="patient-payment-method"> -0</span>
                </div>
                <div class="patient-payment-block">
                    Patient Payment
                    <span class="icon-patient-payment"
                          title="Click for alternate view of patient payment/refund">!</span>
                    <span class="main-patient-payment-method font-total-big">0</span>
                    <span class="patient-payment-method">CREDIT CARD: 0</span>
                    <span class="patient-payment-method">CASH: 0</span>
                    <span class="patient-payment-method">Check: 0</span>
                </div>
                <div>Balance <span class="font-total-big">0</span>
                </div>
                <div>
                    NET COLLECTION <span class="font-total-big">0</span>
                </div>
            </div>
            <ul class="itemlisttable flowlisttype messageflow">
                <li class="itemlisthead">
                    <div style="width: 75px !important; text-align: right !important;">Date</div>
                    <div style="width: 5% !important; text-align: center !important;">Type</div>
                    <div style="width: 5% !important; text-align: left;">Bill#</div>
                    <div style="width: 10% !important; text-align: left;">Vendor</div>
                    <div style="width: 10% !important; text-align: left;">User</div>
                    <div style="width: 20% !important; text-align: left">Listing</div>
                    <div style="width: 27% !important;">Itemized Ticket</div>
                    <div style="width: 10% !important; text-align: right !important;">Amount</div>
                    <div style="width: 5% !important; text-align: right !important;">Status</div>
                    <div style="width: 3% !important; text-align: right !important; padding-right: 10px !important;"></div>
                </li>
                <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt">
                    <i class="fas fa-spinner fa-spin"></i>
                </li>
                <li v-if="!isLoading && dataEvents.length === 0" style="text-align: center; font-size: 16pt">No records
                    found
                </li>

                <li v-if="!isLoading" v-for="(event, index) in dataEvents" @click.prevent="showDetail(event)">
                    <div style="width: 75px !important; font-style: normal !important; text-align: right !important;">
                        <span>{{ formatTime(event.paidDate)}}</span>
                        <span style="display: block">{{ formatOnlyTime12Hour(event.paidDate)}}</span>
                    </div>
                    <div style="width: 5% !important; font-style: normal !important; text-align: center !important;">Event</div>
                    <div style="width: 5% !important; text-align: left;">#{{ event.billId }}</div>
                    <div style="width: 10% !important; text-align: left; text-transform: uppercase !important;"><b>{{ event.groupName }}</b></div>
                    <div style="width: 10% !important; text-align: left;">{{ event.attendant }}</div>
                    <div style="width: 20% !important; text-align: left"><span>{{ event.title }}</span></div>
                    <div style="width: 27% !important; min-height: 1px !important;">
                        <ul class="itemsublist billing-icd" v-if="event.categorySponsor">
                            <li>
                                <span>{{ event.categorySponsor}}: {{ formatStringToView(event.total_ticket) }}</span>
                            </li>
                            <!--<li>-->
                                <!--<span>Exhibitors: {{ formatStringToView(event.amount - event.total_ticket) }}</span>-->
                            <!--</li>-->
                        </ul>
                        <ul class="itemsublist billing-icd" v-if="event.ticketName">
                            <li v-if="event.ticketName">
                                <span>{{ event.ticketName}}: {{ formatStringToView(event.total_ticket) }}</span>
                            </li>
                            <li v-if="event.hotel">
                                <span>{{ event.hotel }}: {{ formatStringToView(event.price_hotel) }}</span>
                            </li>
                            <li v-if="event.addition_title">
                                <span>{{ event.addition_title }}: {{ formatStringToView(event.addition_amount) }}</span>
                            </li>
                        </ul>
                    </div>
                    <div style="width: 10% !important; text-align: right !important;">{{ formatStringToView(event.amount) }}</div>
                    <div style="width: 5% !important; text-align: right !important; min-height: 1px;" :title="event.transaction_reason_error">{{event.transactionStatusText}}</div>
                    <div style="width: 3% !important; text-align: right !important; min-height: 1px; padding-right: 10px !important;">
                        <dropdown>
                            <a href="javascript:void(0)" class="recorddelete"><i
                                    class="fa fa-cog"></i></a>
                            <template slot="dropdown"></template>
                        </dropdown>
                    </div>
                </li>
            </ul>
        </div>

        <br/>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total"></pagination>

        <detail-ticket-event v-if="detailTicket.modal" :detailTicket="detailTicket.data"  @updateModal="detailTicket.modal = $event"></detail-ticket-event>
        <detail-ticket-sponsor v-if="detailSponsor.modal" :detailTicket="detailSponsor.data"  @updateModal="detailSponsor.modal = $event"></detail-ticket-sponsor>
    </div>
</template>

<script>
import axios from '../../client'
import Common from '../mixins/Common.vue'
import Pagination from '../../global/Pagination.vue'
import DatePicker from '../../global/datepicker/DatePickerCustom.vue'
import DetailTicketEvent from '../billing/part/DetailTicketEvent'
import DetailTicketSponsor from '../billing/part/DetailTicketSponsor'
import moment from 'moment'

export default {
  name: 'calendar-daily',
  components: { Pagination, DatePicker, DetailTicketEvent, DetailTicketSponsor },
  mixins: [Common],
  data () {
    return {
      key_search: '',
      isLoading: false,
      dataEvents: [],
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isGeneratingCode: false,
      postEventDate: '',
      endEventDate: '',
      formSearch: {
        keySearch: '',
        fromDate: moment().subtract(1, 'months'),
        toDate: moment()
      },
      detailTicket: {
        data: {},
        modal: false
      },
      detailSponsor: {
        data: {},
        modal: false
      }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    submitSearchBill () {
      this.paginate.page = 1
      this.loadData()
    },
    loadData () {
      if (!this.isLoading) {
        let params = {
          page: this.paginate.page,
          perPage: this.paginate.perPage,
          key: this.formSearch.keySearch,
          fromDate: this.formSearch.fromDate ? moment(this.formSearch.fromDate).format('MM/DD/YYYY') : '',
          toDate: this.formSearch.toDate ? moment(this.formSearch.toDate).format('MM/DD/YYYY') : ''
        }
        this.isLoading = true
        axios.get(`calendar/daily-list`, { params: params }).then(response => {
          this.isLoading = false
          if (response.data.s === 200) {
            this.dataEvents = response.data.data.bills
            this.paginate.total = Number(response.data.data.total)
            this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
          } else {
            this.dataEvents = []
            this.alertError(response.data.msg)
          }
        }).catch(e => {
          this.isLoading = false
          this.alertError('Server error when load data. Press F5 to refresh browser')
        })
      }
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadData()
    },
    showDetail (billing) {
      axios.post(`events-billing/get-detail`, { id: billing.billId }).then(response => {
        if (response.data.s === 200) {
          let data = response.data.data
          if (data.type === 'ticket') {
            this.detailTicket = {
              data: data,
              modal: true
            }
          } else {
            this.detailSponsor = {
              data: data,
              modal: true
            }
            console.log('data', data)
          }
        } else {
          this.alertError(response.data.msg)
        }
      }).catch(e => {
        this.alertError('Server error when load data. Press F5 to refresh browser')
      })
    }
  }
}
</script>

<style>
    #event-group .mx-datepicker {
        width: 17%;
    }

    #event-group .mx-input {
        height: 40px;
    }
</style>

<style scoped>
    .flowsearch > *:first-child {
        width: 20% !important;
        min-width: 150px;
    }

    #daily-bill-report .mx-datepicker {
        width: 120px !important;
        float: none !important;
    }

    #daily-bill-report .bill-info {
        width: 12%;
    }

    .filter-option-block {
        float: none !important;
        width: 120px !important;
    }

    .block-filter-date {
        width: 120px !important;
    }

    .block-filter-batch-number {
        width: 140px !important;
        float: none !important;
    }

    .billinglist div {
        min-height: 1px;
    }

    .onelineform {
        text-align: right;
        border-left: none;
    }

    .keyinput {
        float: none !important;
        border-left: 1px solid #e1e1e1;
    }

    .item-bill div {
        min-height: 1px;
    }

    .ledgersum.daily > div {
        width: 12.5% !important;
        font-size: 11px;
        height: 110px;
        padding: 5px !important;
    }

    .ledgersum.daily > div > span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 11px;
    }

    .patient-payment-method {
        margin-left: 7px;
        font-weight: normal !important;
    }

    .font-total-big {
        font-size: 20px !important;
    }

    .icon-patient-payment {
        color: red;
        font-size: 16px;
        display: inline;
        padding-left: 2px;
        padding-right: 2px;
    }

    .patient-payment-block {
        cursor: pointer;
    }

    .disabled-fee {
        color: gainsboro !important;
    }

    .disabled-fee > div {
        color: gainsboro !important;
    }

    .disabled-adjust {
        color: gainsboro !important;
    }

    /*=======================================*/

    #transmitlist > li {
        display: inline-flex;
        min-width: 100%;
        padding-left: 10px !important;
    }

    #transmitlist > li > div {
        display: inline-block;

    }

    #transmitlist {
        overflow-x: auto;
        overflow-y: hidden !important;
    }

    .itemlisthead div {
        color: inherit !important;
    }

    .sent-block {
        padding-top: 5px;
        position: absolute;
        top: 30%;
        width: 220px !important;
        margin-left: -10px !important;
        font-size: 11px !important;
        font-style: italic;
        text-align: left !important;
    }

    .fullscreen .sent-block {
        margin-left: -20px !important;
    }

    .bill-mrn {
        min-width: 75px !important;
        max-width: 75px !important;
        width: 75px !important;
        padding-right: 5px;
        text-align: center !important;
        padding-left: 0px !important;
    }

    .bill-patient-mrn {
        min-width: 60px !important;
        max-width: 60px !important;
    }

    .bill-patient {
        min-width: 145px !important;
        max-width: 145px !important;
        width: 145px !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden !important;
        font-weight: bold;
        cursor: pointer;
    }

    .bill-transmit {
        min-width: 140px !important;
        max-width: 140px !important;
        width: 140px !important;
    }

    .bill-info {
        min-width: 205px !important;
        max-width: 205px !important;
        display: inline-block;
        vertical-align: top;
        cursor: pointer;
    }

    .bill-info .doctor, .bill-info .location, .bill-info .invisible-insurance {
        text-overflow: ellipsis;
        white-space: nowrap !important;
        overflow: hidden !important;
    }

    .bill-list-cpt > li > div {
        display: inline-block;
    }

    .bill-list-cpt > li {
        clear: both;
    }

    .bill-list-cpt {
        width: 827px;
        display: inline-block;
    }

    .bill-diagnonsis {
        min-width: 205px !important;
        max-width: 205px !important;
        vertical-align: top;
        display: inline-block;
    }

    .bill-fee-data {
        width: 1307px !important;
        overflow: unset !important;
    }

    .bill-fee-data > ul > li > div {
        float: unset !important;
        display: block !important;
    }

    .bill-cpt {
        min-width: 48px !important;
        max-width: 48px !important;
    }

    .bill-procedure {
        min-width: 195px !important;
        max-width: 195px !important;
    }

    .bill-m1, .bill-m2, .bill-m3, .bill-m4 {
        min-width: 20px !important;
        max-width: 20px !important;
    }

    .bill-fQ {
        min-width: 25px !important;
        max-width: 25px !important;
    }

    .bill-charge {
        width: 65px !important;
        min-width: 65px !important;
        max-width: 65px !important;
        text-align: right !important;
    }

    .bill-allowed-amount {
        width: 70px !important;
        min-width: 70px !important;
        max-width: 70px !important;
        text-align: right !important;
        color: #bec500;
    }

    .bill-deduct-amount {
        width: 70px !important;
        min-width: 70px !important;
        max-width: 70px !important;
        text-align: right !important;
    }

    .bill-coins-amount, .bill-copay-amount {
        width: 60px !important;
        min-width: 60px !important;
        max-width: 60px !important;
        text-align: right !important;
    }

    .bill-other-adjust {
        min-width: 90px !important;
        max-width: 90px !important;
        width: 90px !important;
        text-align: right !important;
        color: #faaf3a;
    }

    .bill-insurance-adjust {
        min-width: 70px !important;
        max-width: 70px !important;
        width: 70px !important;
        text-align: right !important;
        color: #faaf3a;
    }

    .bill-provider-paid {
        min-width: 50px !important;
        max-width: 50px !important;
        width: 50px !important;
        text-align: right !important;
        color: #76a6e8;
    }

    .bill-balance {
        width: 70px !important;
        min-width: 70px !important;
        max-width: 70px !important;
        text-align: right;
        font-weight: bold;
        vertical-align: top;
        display: inline-block;
        color: #e87676;
    }

    .bill-action {
        min-width: 50px !important;
        max-width: 50px !important;
        width: 50px !important;
        position: unset !important;
    }

    @media (min-width: 1800px) {
        .bill-action {
            min-width: 100px !important;
            max-width: 100px !important;
            width: 100px !important;
            position: unset !important;
        }
    }

    .bill-action .dropdown {
        float: right
    }

    .secondary-group {
        margin-top: 10px !important;
    }

    .bill-secondary-info {
        width: 410px;
        display: inline-block;
        vertical-align: top;
    }

    .bill-select {
        width: 27px !important;
        text-align: left;
    }

    .secondary-insurance {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .secondary-insurance:before {
        content: "\f2bb";
        font-family: "Font Awesome\ 5 Free";
        font-weight: 900;
        margin-right: 5px;
        display: inline-block;
        width: 15px;
        text-align: right;
    }

    .bill-select-all {
        width: 13px !important;
    }

    .adjust-name {
        width: 288px !important;
    }

    .adjust-amount {
        width: 65px !important;
        text-align: right !important;
    }

    .avatar-patient {
        width: 20px !important;
        padding-bottom: 20px !important;
        display: inline-block !important;
        border-radius: 50% !important;
        vertical-align: middle !important;
        background-size: cover;
        background-position: top center;
        height: 0;
        background-color: #e1e1e1;
        overflow: hidden;
    }

    /*===============================*/

    #daily-bill-report .gb_Df {
        right: 0 !important;
    }
</style>
